<template>
    <div class="init">
        <div class="initImg">
            <img src="../../../assets/img/b2b/img_noenterprise@2x.png" alt="">
        </div>
        <div class="btn">
            <p @click="onCreate"><van-button color="#FF7A45" :round="true" type="default">创建企业</van-button></p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'initPage',
    methods: {
        onCreate () {
            this.$router.push('/b2b/initPage/create')
        }
    }
}
</script>
<style lang="scss" scoped>
    .init{
        height: 100%;
        background: #ffffff;
        .initImg{
            padding: 216px 116px 194px;
        }
        .btn{
            padding: 0 80px;
            p{
                margin-bottom: 48px;
            }
        }
    }
    /deep/ .van-button--normal {
        width: 100%;
        height: 96px;
        line-height: 96px;
        font-size: 32px;
    }
    /deep/ .van-button--default{
        border: 2px solid rgb(255, 122, 69);
    }
</style>